import styled from 'styled-components'
import { Color } from 'root-constants'
import { Review } from 'components/Review'

export const StyledCustomerReviewsListV2 = {
  Wrapper: styled.div`
    margin-top: 40px;
  `,
  Title: styled.div`
    position: relative;
    display: flex;
    align-items: center;
    min-height: 122px;
    font-weight: 700;
    font-size: 32px;
    line-height: 38px;
    color: #13182a;

    strong {
      color: ${Color.ORANGE};
      text-transform: uppercase;
    }
  `,
  TitleText: styled.div`
    max-width: 224px;
  `,
  Img: styled.img`
    position: absolute;
    right: 0;
    top: 0;
  `,
  Review: styled(Review)`
    background: #ebe8ff;

    div {
      color: ${Color.DARK};
    }

    p {
      color: #6e7188;
    }
  `,
}
